export const featuredPortfolio = [{
        id: 1,
        title: "WordPress Template",
        img: "/assets/bio74.jpg",
        link: "https://github.com/pkcnj/wp-custom",
    },
    {
        id: 2,
        title: "WordPress Site",
        img: "/assets/accel-home.jpg",
        link: "https://github.com/pkcnj/accelerate",
    },
    {
        id: 3,
        title: "GitHub Repo Search",
        img: "/assets/gh-repo.jpg",
        link: "https://pkcnj.github.io/github-repo/",
    },
    {
        id: 4,
        title: "Guess the Word",
        img: "/assets/guess.jpg",
        link: "https://pkcnj.github.io/guessing-game/",
    },
    {
        id: 5,
        title: "Event Template",
        img: "/assets/unplug.jpg",
        link: "https://pkcnj.github.io/unplugged-retreat/",
    },
    {
        id: 5,
        title: "Portfolio Template",
        img: "/assets/port-site.jpg",
        link: "https://pkcnj.github.io/template-portfolio/",
    },
];

export const dataPortfolio = [{
        id: 1,
        title: "NYC Library Statistics",
        img: "/assets/rainbow-keys.jpg",
        link: "https://github.com/pkcnj/phpdatabase",
    },
    {
        id: 2,
        title: "Stock Trading",
        img: "/assets/stocks.jpg",
        link: "https://github.com/pkcnj/stocksRT",
    },
    {
        id: 3,
        title: "Studio Ghibli Films",
        img: "/assets/cards.jpg",
        link: "https://pkcnj.github.io/cardsapi/",
    },
    {
        id: 4,
        title: "Open Source Database",
        img: "/assets/teamcraft.jpg",
        link: "https://github.com/pkcnj/ffxiv-teamcraft",
    },
    //{
    //id: 5,
    //title: "Web Design",
    //img: "https://cdn.dribbble.com/users/387658/screenshots/15458608/media/e92ec1dd33dd1170ae3dc9c5272f2693.jpg?compress=1&resize=1200x900",
    //},
    //{
    //id: 6,
    //title: "Web Banking App",
    //img: "https://cdn.dribbble.com/users/6384483/screenshots/15468426/media/ce9479fa1f8dba3a4a49840d76e55e31.png?compress=1&resize=1200x900",
    //},
];

//export const openPortfolio = [{
//id: 1,
//title: "Mobile Social Media App",
//img: "https://cdn.dribbble.com/users/2597268/screenshots/15468893/media/44313553d73ba41580f1df69749bba28.jpg?compress=1&resize=1200x900",
//},
//{
//id: 2,
//title: "Mobile Rampa UI Design",
//img: "https://cdn.dribbble.com/users/5920881/screenshots/15463142/media/b5a460223798bd85d835710806e2f3dd.png?compress=1&resize=1200x900",
//},
//{
//id: 3,
//title: "Mobile E-commerce Design",
//img: "https://cdn.dribbble.com/users/1998175/screenshots/15459384/media/48ac2b43ebe81ba0866afea1383cc939.png?compress=1&resize=1200x900",
//},
//{
//id: 4,
//title: "Mobile Relax App",
//img: "https://cdn.dribbble.com/users/2083704/screenshots/15468619/media/cd958306c7a772449e1ac23bd65ce506.png?compress=1&resize=1200x900",
//},
//{
//id: 5,
//title: "Mobile Hero Design",
//img: "https://cdn.dribbble.com/users/26642/screenshots/15462545/media/1a202ef5c8338b6f78634e6edc1ba350.png?compress=1&resize=1200x900",
//},
//{
//id: 6,
//title: "Mobile Banking App",
//img: "https://cdn.dribbble.com/users/1387827/screenshots/15466426/media/deb2dca6762cd3610321c98bfccb0b72.png?compress=1&resize=1200x900",
//},
//];